import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items, className = "" }) {
  const colors = ["text-brand-blue", "text-brand-magenta"];
  return (
    <div className={`select-none py-10 ${className}`} data-testid="editorial-marquee">
      <Marquee speed={26} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span
              className={`font-display text-6xl font-semibold uppercase tracking-tight sm:text-8xl ${
                i % 3 === 0 ? colors[0] : i % 3 === 1 ? "stroke-text" : colors[1]
              }`}
            >
              {it}
            </span>
            <span className="h-3 w-3 rotate-45 bg-brand-magenta" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
